import Menu from "./components/menu";
import Tabs from "./components/tabs";
import Sliders from './components/sliders';

window.addEventListener("load", function () {
  new Sliders;
  new Menu;
  new Tabs;
});
